
import { Component, Vue } from "vue-property-decorator";
import ImageAssetsUrlUtil from "@/libs/util/ImageAssetsUrlUtil";
import MainApp from "@/libs/MainApp";
import WorldCupComponent from "@/libs/WorldCupComponent";

@Component({})
export default class Unknown extends WorldCupComponent {
  assetUtil: ImageAssetsUrlUtil;
  $root: MainApp;
  componentImage: string;
  created() {
    this.assetUtil = new ImageAssetsUrlUtil(this.getConfig().assetPoint);
    this.componentImage = this.assetUtil.getUrl("jigsaw.jpg");
  }
}
